// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_80ad21f8ef--wrapper--lPKzG","content":"_80ad21f8ef--content--2h9hk"};